import {Base64} from 'js-base64';

import {logger} from 'utils/logger'; // Fix circular dependency

class MapStorage implements Storage {
    static values = new Map<string, string>();

    getItem(key: string): string | null {
        if (MapStorage.values.has(key)) {
            return MapStorage.values.get(key);
        }
        return null;
    }

    setItem(key: string, value: string) {
        MapStorage.values.set(key, value);
    }

    removeItem(key: string) {
        MapStorage.values.delete(key);
    }

    clear() {
        MapStorage.values.clear();
    }

    key(index: number): string | null {
        if (arguments.length === 0) {
            // this is a TypeError implemented on Chrome, Firefox throws Not enough arguments to Storage.key.
            throw new TypeError('Failed to execute \'key\' on \'Storage\': 1 argument required, but only 0 present.');
        }
        const arr = Array.from(MapStorage.values.keys());
        return arr[index];
    }

    get length(): number {
        return MapStorage.values.size;
    }
}

function getStorageIfAvailable(storageName: string): Storage | false {
    try {
        const key = '__storage_test__';
        const storageToTest = window[storageName];
        storageToTest.setItem(key, key);
        storageToTest.removeItem(key);
        return storageToTest;
    } catch (e) {
        logger.warn(`"${storageName}" is not available. Can not use it for the app purposes. Some feature can work wrong`);
        return false;
    }
}

const mapStorage = new MapStorage();
export const storage: Storage =
    getStorageIfAvailable('localStorage') ||
    getStorageIfAvailable('sessionStorage') ||
    mapStorage;

const getItem = (key: string): any => {
    let item: any = null as any;
    try {
        const notParsedItem = storage.getItem(key);
        if (notParsedItem) {
            item = JSON.parse(notParsedItem);
        }
    } catch {
        // Do nothing
    }
    return item;
};

const setItem = (key: string, value: any) => {
    storage.setItem(key, JSON.stringify(value));
};

const removeItem = (key: string) => {
    storage.removeItem(key);
};

export {
    getItem, setItem, removeItem
};

export class KeyStorage<T> {
    constructor(private key: string, private options?: {base64?: boolean}) {
    }

    private encodeBase64 = Base64.encode;
    private decodeBase64 = Base64.decode;

    public getItem = (): T => {
        const data = getItem(this.key);
        if (!this.options?.base64) {
            return data;
        }
        try {
            return JSON.parse(this.decodeBase64(data));
        } catch {
            return null;
        }
    };

    public hasItem = (): boolean => !!getItem(this.key);
    public setItem = (data: T) => setItem(this.key, this.options?.base64 ? this.encodeBase64(JSON.stringify(data)) : data);
    public removeItem = () => removeItem(this.key);
}
